import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { SlicePipe } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { SwiperOptions } from 'swiper/types/swiper-options';
import { SafeUrlPipe } from 'src/app/shared/pipes/safe-url.pipe';
import { SwiperDirective } from 'src/app/shared/directives/swiper.directive';

const GALLERY_SWIPER_OPTIONS: SwiperOptions = {
  slidesPerView: 1,
  spaceBetween: 16,
  autoplay: {
    delay: 7000,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    375: {
      spaceBetween: 16,
    },
    524: {
      spaceBetween: 20,
    },
    768: {
      spaceBetween: 24,
    },
    1100: {
      spaceBetween: 32,
    },
  },
};

@Component({
  selector: 'app-gallery-mobile',
  templateUrl: './gallery-mobile.component.html',
  styleUrls: ['gallery-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SwiperDirective, TranslateModule, SafeUrlPipe, SlicePipe],
})
export class GalleryMobileComponent {
  @Input() destinations: any[] = [];
  @Output() selectedItem: EventEmitter<any> = new EventEmitter<any>();

  protected readonly swiperOptions: SwiperOptions = GALLERY_SWIPER_OPTIONS;
}
